export const Hours = {
    am12: { id: 1, label: '12 am' },
    am1: { id: 2, label: '1' },
    am2: { id: 3, label: '2' },
    am3: { id: 4, label: '3' },
    am4: { id: 5, label: '4' },
    am5: { id: 6, label: '5' },
    am6: { id: 7, label: '6' },
    am7: { id: 8, label: '7' },
    am8: { id: 9, label: '8' },
    am9: { id: 10, label: '9' },
    am10: { id: 11, label: '10' },
    am11: { id: 12, label: '11' },
    pm12: { id: 13, label: '12 pm' },
    pm1: { id: 14, label: '1' },
    pm2: { id: 15, label: '2' },
    pm3: { id: 16, label: '3' },
    pm4: { id: 17, label: '4' },
    pm5: { id: 18, label: '5' },
    pm6: { id: 19, label: '6' },
    pm7: { id: 20, label: '7' },
    pm8: { id: 21, label: '8' },
    pm9: { id: 22, label: '9' },
    pm10: { id: 23, label: '10' },
    pm11: { id: 24, label: '11' }
}